import { instance } from './ApiRequest';
import {
    PUBLICATION_GET_ACTIVE, PUBLICATION_GET_DOCUMENT_ACCESS_URL, PUBLICATION_GET_ALL, PUBLICATION_GET_BY_ID,
    PUBLICATION_CREATE, PUBLICATION_UPDATE, PUBLICATION_PUBLISH, PUBLICATION_UNPUBLISH, PUBLICATION_ARCHIVE,
    PUBLICATION_SUPERSEDE
} from 'constants/constants';

// Phase C.1 (Enterprise Publication Foundation) — a dedicated module for the new backend surface,
// following the same "one small module per related API surface" convention EnterpriseOpsService.js
// established, rather than folding these into the large legacy AdminService.js.
let _PublicationService = {
    // Candidate-facing, anonymous.
    async getActivePublications(maxCount) {
        return await instance.get(PUBLICATION_GET_ACTIVE + "?maxCount=" + (maxCount || 3));
    },
    async getDocumentAccessUrl(publicationId) {
        return await instance.get(PUBLICATION_GET_DOCUMENT_ACCESS_URL + "?publicationId=" + publicationId);
    },

    // Admin-facing, Global-Admin-gated on the backend.
    async getAll() {
        return await instance.get(PUBLICATION_GET_ALL);
    },
    async getById(id) {
        return await instance.get(PUBLICATION_GET_BY_ID + "?id=" + id);
    },
    // `file` is a browser File object; metadata fields are appended alongside it in the same FormData,
    // mirroring the existing candidate-upload convention (e.g. CandidateImageSignature_new.jsx).
    async create(model, file) {
        const body = new FormData();
        appendModelFields(body, model);
        body.append('files[]', file);
        return await instance.post(PUBLICATION_CREATE, body);
    },
    async update(id, model) {
        return await instance.post(PUBLICATION_UPDATE + "?id=" + id, model);
    },
    async publish(id) {
        return await instance.post(PUBLICATION_PUBLISH + "?id=" + id);
    },
    async unpublish(id) {
        return await instance.post(PUBLICATION_UNPUBLISH + "?id=" + id);
    },
    async archive(id) {
        return await instance.post(PUBLICATION_ARCHIVE + "?id=" + id);
    },
    async supersede(existingPublicationId, model, file) {
        const body = new FormData();
        appendModelFields(body, model);
        body.append('files[]', file);
        return await instance.post(PUBLICATION_SUPERSEDE + "?existingPublicationId=" + existingPublicationId, body);
    }
};

function appendModelFields(body, model) {
    body.append('PublicationType', model.PublicationType || '');
    body.append('Title', model.Title || '');
    body.append('Description', model.Description || '');
    body.append('PublicationLanguage', model.PublicationLanguage || '');
    body.append('PublicationDate', model.PublicationDate || '');
    body.append('EffectiveDate', model.EffectiveDate || '');
    body.append('DisplayOrder', model.DisplayOrder != null ? model.DisplayOrder : 0);
}

export default _PublicationService;
